/* Green Gorilla Fruits — referral link capture
 * --------------------------------------------------------------
 * Captures ?ref=REF-XXXXXXXX from any landing URL and persists it
 * for 30 days in both LocalStorage and a SameSite=Lax cookie so
 * the code survives across pages and after the visitor signs up.
 *
 * Public API: window.GG_Referral.getCode() / .clear()
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'gg_referral_code';
  const COOKIE_NAME = 'gg_referral_code';
  const RETENTION_DAYS = 30;
  const MS_PER_DAY = 86400000;
  const CODE_RE = /^REF-[A-Z0-9]{8}$/;

  function readStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.code || !CODE_RE.test(parsed.code)) return null;
      if (typeof parsed.expires === 'number' && Date.now() > parsed.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed.code;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(code) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ code, expires: Date.now() + RETENTION_DAYS * MS_PER_DAY })
      );
    } catch (e) {
      /* private mode / quota — fall back to cookie only */
    }
  }

  function readCookie() {
    const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]+)'));
    if (!match) return null;
    const value = decodeURIComponent(match[1]);
    return CODE_RE.test(value) ? value : null;
  }

  function writeCookie(code) {
    const maxAge = RETENTION_DAYS * 24 * 60 * 60;
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(code) +
      '; Max-Age=' +
      maxAge +
      '; Path=/; SameSite=Lax' +
      secure;
  }

  function clearAll() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=; Max-Age=0; Path=/; SameSite=Lax' + secure;
  }

  function persist(code) {
    writeStorage(code);
    writeCookie(code);
  }

  function stripQueryParam() {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('ref');
      const next =
        url.pathname +
        (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') +
        url.hash;
      history.replaceState(history.state, '', next);
    } catch (e) {
      /* older browsers — leave the URL alone */
    }
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    const incoming = params.get('ref');
    if (incoming && CODE_RE.test(incoming)) {
      persist(incoming);
      stripQueryParam();
      return;
    }
    const stored = readStorage() || readCookie();
    if (stored) {
      persist(stored);
    }
  }

  window.GG_Referral = {
    getCode: function () {
      return readStorage() || readCookie();
    },
    clear: clearAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
